import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Settings from '../Settings/Settings';
import FormBlock from "../FormBlock/FormBlock";
import IssuanceBlock from '../IssuanceBlock/IssuanceBlock';

import {getMainData, resetStep} from '../../actions/card';

import './styles/mainBlock.scss';
import ConfirmationBlock from "../ConfirmationBlock/ConfirmationBlock";
import {urlParam} from "../../helpers/urlParam";
import {getUtmFromStorage, pushUrlWithUtm, saveUtmToStorage, utmProps} from "../../helpers/linkWithUtm";

const MIN_HEIGHT = 740;

class MainBlock extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 3,
            maxStep: 3
        }
    }

    async componentDidMount() {
        this.props.getMainData();

        saveUtmToStorage();

        //если в url есть хоть один из параметров меток, не восстанавливаем из хранилища
        if(!utmProps.some(param => urlParam(param))) {
            console.log('utm doesnt exist')
            let params = getUtmFromStorage();
            if(params)
                await pushUrlWithUtm(params);
            try {
                window.yaCounter38953865.hit(window.location.href)
            } catch (error) {
                console.log('error last screen analytics', error);
            }
        }
    }

    changeStep(number) {
        this.setState({
            step: number,
            maxStep: number
        });

        // scroll to top for short screen
        if (window.innerHeight <= MIN_HEIGHT) {
            window.scrollTo(0, 0);
        }
    }

    changeMaxStep(number) {
        this.setState({
            maxStep: number
        },() => {
            this.props.resetStep(number);
        })
    }

    backStep(number) {
        if (number <= this.state.maxStep) {
            this.setState({
                step: number
            });

            this.props.resetStep(number);

            // scroll to top for short screen
            if (window.innerHeight <= MIN_HEIGHT) {
                window.scrollTo(0, 0);
            }
        }
    }

    render() {

        const {
            history,
            params
        } = this.props;

        return (
            <div>
                    {
                        this.state.step === 2
                        ? <Settings
                                changeStep={this.changeStep.bind(this)}
                                changeMaxStep={this.changeMaxStep.bind(this)}
                            />
                        :   null
                    }

                    {
                        this.state.step === 3
                            ? <FormBlock
                                    step={this.state.step}
                                    maxStep={this.state.maxStep}
                                    history={history}
                                    params={params}
                                    backStep={this.backStep.bind(this)}
                                    changeStep={this.changeStep.bind(this)}
                                    changeMaxStep={this.changeMaxStep.bind(this)}
                                />
                            :   null
                    }
                    {
                        this.state.step === 4
                          ? <ConfirmationBlock
                                step={this.state.step}
                                maxStep={this.state.maxStep}
                                history={history}
                                backStep={this.backStep.bind(this)}
                                changeStep={this.changeStep.bind(this)}
                          />
                          :   null
                    }
                    {
                        this.state.step === 5
                        ? <IssuanceBlock
                                step={this.state.step}
                                maxStep={this.state.maxStep}
                                history={history}
                                backStep={this.backStep.bind(this)}
                            />
                        :   null
                    }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        mainData: state.card.mainData,
        resultCard: state.card.resultCard
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    getMainData,
    resetStep
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MainBlock)